/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveGroupEmergencyContactAuthIdsRequest
 */
export interface RemoveGroupEmergencyContactAuthIdsRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveGroupEmergencyContactAuthIdsRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveGroupEmergencyContactAuthIdsRequest
     */
    group_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveGroupEmergencyContactAuthIdsRequest
     */
    auth_ids: Array<string>;
}

/**
 * Check if a given object implements the RemoveGroupEmergencyContactAuthIdsRequest interface.
 */
export function instanceOfRemoveGroupEmergencyContactAuthIdsRequest(value: object): value is RemoveGroupEmergencyContactAuthIdsRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_id' in value) || value['group_id'] === undefined) return false;
    if (!('auth_ids' in value) || value['auth_ids'] === undefined) return false;
    return true;
}

export function RemoveGroupEmergencyContactAuthIdsRequestFromJSON(json: any): RemoveGroupEmergencyContactAuthIdsRequest {
    return RemoveGroupEmergencyContactAuthIdsRequestFromJSONTyped(json, false);
}

export function RemoveGroupEmergencyContactAuthIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveGroupEmergencyContactAuthIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'group_id': json['group_id'],
        'auth_ids': json['auth_ids'],
    };
}

export function RemoveGroupEmergencyContactAuthIdsRequestToJSON(json: any): RemoveGroupEmergencyContactAuthIdsRequest {
    return RemoveGroupEmergencyContactAuthIdsRequestToJSONTyped(json, false);
}

export function RemoveGroupEmergencyContactAuthIdsRequestToJSONTyped(value?: RemoveGroupEmergencyContactAuthIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'group_id': value['group_id'],
        'auth_ids': value['auth_ids'],
    };
}

